import * as React from 'react';
import {getAmountToDisplay, getRemainingSpreadAmount} from "../../CommonFunctions";

export const paymentPlanUpdatedRefundModal = (returnPremium: any, monthlyPremium: any, previousMonthlyPremium: any, instalmentsNotPaidOff: boolean): React.ReactNode => {
    if(instalmentsNotPaidOff) {
        return (
            <div className="font-weight-extra-light">
                <p>You currently pay <span className="font-weight-semi-bold">
                    {getAmountToDisplay(previousMonthlyPremium)}
                </span> a month.</p>
                <p>The refund of <span className="font-weight-semi-bold">
                    {getAmountToDisplay(returnPremium)}
                </span> has reduced your remaining monthly
                    payments to <span className="font-weight-semi-bold">
                        {getAmountToDisplay(monthlyPremium)} / month</span>.
                </p>
            </div>
        )
    } else {
        return (
            <div className="font-weight-extra-light">
                We’ve saved your changes, and we’ll refund you{' '}
                <span className="font-weight-bold">{getAmountToDisplay(returnPremium)}.</span>{' '}
                Please allow two days for it to arrive.
            </div>
        );
    }
}

export const paymentPlanUpdatedAdditionalPremiumModal = (factors: any, previousMonthlyPremium: any): React.ReactNode => {
    return (
        <div className="font-weight-extra-light">
            <p>You currently pay <span className="font-weight-semi-bold">
                    {getAmountToDisplay(previousMonthlyPremium)}
                </span> a month.
            </p>
            <p>The additional cost of <span className="font-weight-semi-bold">
                        {getRemainingSpreadAmount(factors)}
                    </span> has increased your remaining monthly payments to <span className="font-weight-semi-bold">
                {getAmountToDisplay(factors.monthlyPremium)} / month.</span>
            </p>
        </div>
    )
}

export const paymentSuccessfulAdditionalPremiumModal = (additionalPremium: any, cardNumber: string, modalContent: any, agreeToReuseCardDetails: boolean | null): React.ReactNode => {
    return (
        <>
            <p className="mb-0 font-weight-extra-light">
                <span className="font-weight-semi-bold">
                    {getAmountToDisplay(additionalPremium)}
                </span> has been debited from your credit card ending <span className="font-weight-semi-bold">
                {cardNumber.slice(-4)}</span>{" "}
                {modalContent}
            </p>
            <p>
                Please allow a couple of minutes for the payment to be updated in your account.
            </p>
            {agreeToReuseCardDetails && (
                <p className="mb-0 font-weight-extra-light">
                    Your future payments will now be taken from this card.
                </p>
            )}
        </>
    )
}

export const paymentSuccessfulAdditionalPremiumMonthlyModal = (upfrontPaymentAmount: any, monthlyPaymentSpreadAmount: any, cardNumber: string, modalContent: any, didSwitchPaymentCard: boolean | null): React.ReactNode => {
    return (
        <>
            <p className="mb-0 font-weight-extra-light">
                <span className="font-weight-semi-bold">
                    {getAmountToDisplay(upfrontPaymentAmount)}
                </span> has been debited from your credit card ending <span className="font-weight-semi-bold">
                {cardNumber.slice(-4)}</span>{" "}
                {modalContent}
            </p>
            <p>
                Please allow a couple of minutes for the payment to be updated in your account.
            </p>
            {didSwitchPaymentCard && (
                <p className="mb-0 font-weight-extra-light">
                    Your future payments will now be taken from this card.
                </p>
            )}
            {upfrontPaymentAmount < monthlyPaymentSpreadAmount && (
                <p className="mb-0 font-weight-extra-light">
                    The remaining {getAmountToDisplay(monthlyPaymentSpreadAmount)} has been added to
                    your monthly payments.
                </p>
            )}
        </>
    )
}

export const paymentSuccessfulRefundModal = (returnPremium: any, modalContent: any): React.ReactNode => {
    return (
        <>
            <p className="font-weight-extra-light">
                We’ve saved your changes, and we’ll refund you <span className="font-weight-semi-bold">
                {getAmountToDisplay(returnPremium)}</span>{" "}
                {modalContent}{" "}
            </p>
            <p>
                Please allow two days for it to arrive.
            </p>
        </>
    )
}
